import { LINK } from '@/constants';
// import useAvadaIntegrationAdapter from './adapters/useAvadaIntegrationAdapter';
import useTrustpilotIntegrationAdapter from './adapters/useTrustpilotIntegrationAdapter';
import TrustpilotConfigView from './configTabs/trustpilot/TrustpilotConfigView';
import { IntegrationConfig } from './types';

export const getIntegrationsConfig = (shop?: string): IntegrationConfig[] => [
  {
    id: 'shopify-flow',
    title: 'Shopify Flow',
    description:
      'Use real-time shipping updates to trigger emails, apply tags, and connect with any app through automated workflows.',
    avatar: 'https://cdn.shopify.com/app-store/listing_images/15100ebca4d221b650a7671125cd1444/icon/CO25r7-jh4ADEAE=.png',
    avatarAlt: 'Shopify Flow Logo',
    platformLink: LINK.INTEGRATE_SHOPIFY_FLOW,
    getAppLink: `https://admin.shopify.com/store/${shop?.split('.')[0]}/apps/flow`,
    connectable: false,
  },
  // Avada is temporarily hidden from the UI. Uncomment this block and the import above to re-enable it.
  // {
  //   id: 'avada',
  //   title: 'AVA SMS,Email Marketing,Pop Up',
  //   description: 'Send out personalized notifications by SMS, Email, Whatsapp with shipping updates from Omega - Order tracking.',
  //   avatar: `${process.env.REACT_APP_S3_ASSETS_BASE_URL}/images/avadaLogo.svg`,
  //   avatarAlt: 'Avada Logo',
  //   platformLink: LINK.INTEGRATE_AVADA,
  //   getAppLink: LINK.GET_AVADA_APP,
  //   connectable: true,
  //   fields: [
  //     { key: 'appID', label: 'App ID', type: 'text' },
  //     { key: 'secretKey', label: 'Secret Key', type: 'password' },
  //   ],
  //   useAdapter: useAvadaIntegrationAdapter,
  // },
  {
    id: 'trustpilot',
    title: 'Trustpilot',
    description: 'Automatically send review invitations to customers after their orders are successfully delivered.',
    avatar: `https://media.synctrack.io/megamind-ordertracking/uploads/2026/09/cd8b5275-4c52-4a4d-8fde-00b238e5b762.png`,
    avatarAlt: 'Trustpilot Logo',
    platformLink: LINK.INTEGRATE_TRUSTPILOT,
    getAppLink: LINK.GET_TRUSTPILOT_APP,
    connectable: true,
    fields: [
      { key: 'clientId', label: 'API Key', type: 'text', required: true },
      { key: 'clientSecret', label: 'API Secret', type: 'password', required: true },
      {
        key: 'businessUserId',
        label: 'Business User ID',
        type: 'text',
        required: false,
        helpText: 'Optional, but recommended — helps us verify your Trustpilot Business Unit automatically.',
      },
    ],
    useAdapter: useTrustpilotIntegrationAdapter,
    ConfigView: TrustpilotConfigView,
  },
  {
    id: 'pagefly',
    title: 'PageFly Landing Page Builder',
    description: 'Build Landing, Product Page. Compatible with Online Store 2.0',
    avatar: `${process.env.REACT_APP_S3_ASSETS_BASE_URL}/images/pagefly.png`,
    avatarAlt: 'PageFly Logo',
    getAppLink: LINK.GET_PAGE_FLY_APP,
    connectable: false,
  },
];
